import { Button, Column, ErrorBox, InformationBox, Password, Row, TextInput } from "../../../../widget";
import { useAcceptInvitationForm } from "./useAcceptInvitationForm";

interface AcceptInvitationFormProps {
  urlToken: string;
  email: string;
  firstName: string;
  isSharedInvitation: boolean;
  lastName: string;
  onSuccess: (e: boolean) => void;
}

export const AcceptInvitationForm = ({
  urlToken,
  email,
  firstName,
  isSharedInvitation,
  lastName,
  onSuccess,
}: AcceptInvitationFormProps): JSX.Element => {
  const {
    emailOverride,
    newPassword,
    newPasswordConfirmation,
    errors,
    firstNameOverride,
    isHandleSubmitLoading,
    lastNameOverride,
    setEmailOverride,
    setFirstNameOverride,
    setNewPassword,
    setNewPasswordConfirmation,
    setLastNameOverride,
    handleSubmit,
  } = useAcceptInvitationForm(urlToken, email, firstName, lastName, isSharedInvitation, onSuccess);

  return (
    <>
      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox title="Please check your details" text={errors.map((error) => error.message)} />
          </Column>
        </Row>
      )}
      <form className={isSharedInvitation ? "AcceptInvitationSharedForm" : undefined} onSubmit={(e) => handleSubmit(e)}>
        <Row spacingV="ll">
          {isSharedInvitation ? (
            <Column span={12}>
              <TextInput
                name="firstNameOverride"
                label="First name"
                value={firstNameOverride}
                onChange={(value) => setFirstNameOverride(value)}
              />
            </Column>
          ) : (
            <Column span={12}>
              <TextInput type="email" name="email" label="Email address" value={email} disabled />
            </Column>
          )}
        </Row>
        {isSharedInvitation && (
          <>
            <Row spacingV="ll">
              <Column span={12}>
                <TextInput
                  name="lastNameOverride"
                  label="Last name"
                  value={lastNameOverride}
                  onChange={(value) => setLastNameOverride(value)}
                />
              </Column>
            </Row>
            <Row spacingV="ll">
              <Column span={12}>
                <TextInput
                  type="email"
                  name="emailOverride"
                  label="Email"
                  value={emailOverride}
                  onChange={(value) => setEmailOverride(value)}
                />
              </Column>
            </Row>
          </>
        )}
        <Row spacingV="ll">
          <Column span={12}>
            <InformationBox variant="info" title="Password requirements">
              <ul>
                <li>Be at least 8 characters long</li>
                <li>
                  Not be a commonly used password such as <q>Password1</q>
                </li>
              </ul>
            </InformationBox>
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <Password
              label="Password"
              name="newPassword"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.currentTarget.value);
              }}
            />
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <Password
              label="Confirm password"
              name="newPasswordConfirmation"
              value={newPasswordConfirmation}
              onChange={(e) => {
                setNewPasswordConfirmation(e.currentTarget.value);
              }}
            />
          </Column>
        </Row>
        <Row spacingV={isSharedInvitation ? "xl" : undefined}>
          <Column span={12}>
            <Button fullWidth type="submit" text="Accept invitation" isLoading={isHandleSubmitLoading} />
          </Column>
        </Row>
      </form>
    </>
  );
};
